// Tidy Merch: animated counters + catalog filters.
// Scroll-reveal and hover-lift are handled by Dawn's existing
// `scroll-trigger` / `animate--*` classes and animations.js — no need to
// duplicate that here.

(() => {
  const counters = document.querySelectorAll('[data-tm-counter]');
  if (counters.length) {
    const animateCounter = (el) => {
      const target = parseFloat(el.dataset.tmCounter);
      const suffix = el.dataset.tmSuffix || '';
      const decimals = el.dataset.tmCounter.includes('.') ? el.dataset.tmCounter.split('.')[1].length : 0;
      const duration = 1200;
      const start = performance.now();

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach((el) => observer.observe(el));
  }

  const vendorFilterBar = document.querySelector('[data-tm-catalog-vendor-filters]');
  const categoryFilterBar = document.querySelector('[data-tm-catalog-category-filters]');
  const catalogItems = document.querySelectorAll('[data-tm-catalog-item]');
  if (catalogItems.length && (vendorFilterBar || categoryFilterBar)) {
    let activeVendor = 'all';
    let activeCategory = 'all';

    const applyCatalogFilters = () => {
      catalogItems.forEach((item) => {
        const matchesVendor = activeVendor === 'all' || item.dataset.tmVendor === activeVendor;
        const matchesCategory = activeCategory === 'all' || item.dataset.tmCategory === activeCategory;
        // item has an inline `style="display: block"` (see tm-premium-catalog.liquid),
        // which beats the `hidden` attribute's UA-stylesheet `display: none` — toggle
        // the inline style directly instead.
        item.style.display = matchesVendor && matchesCategory ? 'block' : 'none';
      });
    };

    vendorFilterBar?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tm-vendor-filter]');
      if (!button) return;
      vendorFilterBar.querySelectorAll('[data-tm-vendor-filter]').forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');
      activeVendor = button.dataset.tmVendorFilter;
      applyCatalogFilters();
    });

    categoryFilterBar?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tm-category-filter]');
      if (!button) return;
      categoryFilterBar.querySelectorAll('[data-tm-category-filter]').forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');
      activeCategory = button.dataset.tmCategoryFilter;
      applyCatalogFilters();
    });
  }
})();
